module.exports = "/shared/img/grey-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/grey-bck.png
// module id = 21
// module chunks = 13